import type { BudgetData } from "../components/BudgetSelector";

/**
 * Convert form {@link BudgetData} (major units, e.g. USD dollars) to minor units (cents for USD).
 *
 * Use for guided-edit PUT `budget.amount.amount` and launch POST flat `budget.amount` (cents) —
 * same units as GET `GuidedEditPayload.budget.amount`.
 */
export function wireGuidedEditBudgetFromFormDollars(budget: BudgetData): {
  type: "daily" | "lifetime";
  amount: { amount: number | null; currency: string };
} {
  const budgetType: "daily" | "lifetime" =
    budget.type === "daily" ? "daily" : "lifetime";
  const major = budget.amount?.amount;
  const minor =
    major != null && !Number.isNaN(Number(major))
      ? Math.round(Number(major) * 100)
      : null;
  return {
    type: budgetType,
    amount: {
      amount: minor,
      currency: budget.amount?.currency ?? "USD",
    },
  };
}
